import React from "react";
import { useSelector } from "react-redux";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExplosion } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "stores/Store";
import { GameStateEnum } from "interfaces/game";
import { motion } from "framer-motion";
import { InfinitySpin } from "react-loader-spinner";

type WaitingGameProps = {
  message: string;
};

function WaitingGame({ message }: WaitingGameProps) {
  const lobby = useSelector((state: RootState) => state.lobbyReducer.lobby);
  const game = useSelector((state: RootState) => state.gameReducer.game);

  const leaveGame = async () => {
    const db = getFirestore();
    if (lobby?.id) {
      await updateDoc(doc(db, "lobbies", lobby.id), {
        state: GameStateEnum.CANCELLED,
      });
    }
    if (game?.id) {
      await updateDoc(doc(db, "games", game.id), {
        state: GameStateEnum.CANCELLED,
      });
    }
  };

  return (
    <div className="WaitingGame">
      <InfinitySpin width="200" color="#cc3032" />
      <h3 className="waitingPhrase">{message}</h3>
      {game?.mode === "friendly" && (
        <h3 className="waitingPhrase">
          Share this code {lobby?.id} with your friend. <br />
          It has been copied to your clipboard!
        </h3>
      )}
      <motion.button
        className="waitingButton"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={leaveGame}
      >
        <FontAwesomeIcon className="icon" icon={faExplosion} />
        Leave queue
      </motion.button>
    </div>
  );
}

export default WaitingGame;
